module.exports = __webpack_public_path__ + "static/media/taiwan.b5fb939f.svg";